<template>
  <div class="common_drapdown" :style="{ 'min-width': minWidth ? `${minWidth}px` : 'auto' }">
    <h3 class="title" :style="`height: ${titleH}px; line-height: ${titleH}px;`">
      <span v-if="list[active]" class="name">{{ list[active].name }}</span><em class="icon" />
    </h3>
    <ul class="list_box">
      <li
        v-for="(item, index) in list" :key="item.id" class="list_item"
        @click="search(item, index)">{{ item.name }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Drapdown',

  props: {
    minWidth: {
      type: Number,
      default: 0
    },

    titleH: {
      type: Number,
      default: 55
    },

    list: {
      type: Array,
      default: () => ([])
    },

    defaultActive: {
      type: Number,
      default: 0
    },

    mountedDefault: {
      type: Boolean,
      default: false
    },

    keyStr: {
      type: String,
      default: 'id'
    },

    nameKey: {
      type: String,
      default: 'name'
    }
  },

  data () {
    return { active: this.defaultActive }
  },

  watch: {
    list () {
      this.active = this.defaultActive
    }
  },

  mounted () {
    this.mountedDefault && this.search(this.list[this.active], this.defaultActive)
  },

  methods: {
    search (item, index) {
      this.active = index
      this.$emit('select', { index, item })
    },

    reset () {
      this.active = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.common_drapdown {
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover {
    .icon { transform: rotate(180deg); }
    .list_box { display: block; }
  }
  .title { padding: 0 10px; font-size: 16px; color: $font_color_8; text-align: center; }
  .name { vertical-align: middle; }
  .icon { display: inline-block; width: 16px; height: 8px; margin-left: 6px; vertical-align: middle; background-image: url(~@/assets/images/icon_drapdown.svg); background-size: cover; }

  .list_box { position: absolute; z-index: 1; display: none; width: 100%; padding: 5px 0; text-align: center; background-color: #fff; box-shadow: $box_shadow_2; }

  .list_item {
    height: 30px;
    font-weight: 400;
    line-height: 30px;
    color: $font_color_5;

    &:hover { font-weight: bold; color: $font_color; background-color: #e0e2e9; }
  }
}
</style>
